import React from "react"
import { MyFormControlHelpers, CSuppense } from "@macashipo/mlib"

const V1_mfc_mycontrol = React.lazy(
  () => import("src/core/modules/v1page/MyForm/Types/v1_mfc_mycontrol")
)

const ListControl = {
  input_currency: "input_currency",
  input_percentage: "input_percentage",
  input_text: "input_text",
  input_number: "input_number",
  group_controls: "group_controls",
  input_date: "input_date",
  select2_update_more_fields: "select2_update_more_fields",
  v1_mfc_select2: "v1_mfc_select2",
  input_checkbox: "input_checkbox",
  input_checkbox_custom: "input_checkbox_custom",
}
const MyFormControlSMSFOne = {
  init() {
    for (let k of Object.keys(ListControl)) {
      MyFormControlHelpers.addTypes(k, props => {
        return CSuppense({ ...props, typeControl: k }, V1_mfc_mycontrol)
      })
    }
  },
}

export default MyFormControlSMSFOne
